import axios from 'axios';

// Configure axios defaults
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.timeout = 60000;
axios.defaults.headers.common['Content-Type'] = 'application/json';

/**
 * Set authorization token for all requests
 */
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

/**
 * Create axios instance with custom config
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 * Add request interceptor to include token from localStorage
 */
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Add response interceptor to handle 401 errors
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token might be invalid or expired
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      // You could trigger a redirect to login here if needed
    }
    return Promise.reject(error);
  }
);

export default axios;
